<!--
  RenderShimmer.vue -- the ONE shimmer block for "waiting on an Artifi
  preview" (Jake: the shimmer shows everywhere the UI waits for a render, in
  every pending state, not just on a color switch).

  It owns the look only (gradient sweep + animation); the SIZE and shape come
  from the caller's class/style, because a Stage tile, a picker tile and a
  cart thumbnail are different boxes. Attributes (data-testid, class, role,
  style) fall through to the root element.

  Used by: Stage (stage-shimmer), StorefrontListingPanel (pending tile),
  CartItemList (cart-preview-shimmer-<n>). GarmentPreview keeps its own
  overlay sweep on the schematic; that one is drawn OVER an image, not as a
  placeholder block.
-->
<template>
    <div class="render-shimmer" />
</template>

<style scoped>
.render-shimmer {
    background: linear-gradient(
        90deg,
        var(--tf-shimmer-base, #e5e7eb) 0%,
        var(--tf-shimmer-highlight, #f3f4f6) 50%,
        var(--tf-shimmer-base, #e5e7eb) 100%
    );
    background-size: 200% 100%;
    animation: render-shimmer 1.4s linear infinite;
}

/* Static block for people who ask for less motion (as GarmentPreview does). */
@media (prefers-reduced-motion: reduce) {
    .render-shimmer {
        animation: none;
    }
}

@keyframes render-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}
</style>
